// src/components/UpsellBlock.js — Блок допродаж в корзине

import React, { useState, useEffect } from 'react';
import { getProductImage } from '../config/imageMap';
import OptimizedImage from './OptimizedImage';

function UpsellBlock({ onAddItem, cartSkus }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch('/api/upsell-items')
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          const filtered = data.items.filter(p => !cartSkus.includes(String(p.sku)));
          setProducts(filtered.slice(0, 4));
        }
      })
      .catch(() => {});
  }, [JSON.stringify(cartSkus)]); // eslint-disable-line

  if (products.length === 0) return null;

  return (
    <div className="upsell-block">
      <p className="upsell-block__title">Добавьте к заказу</p>
      <div className="upsell-block__items">
        {products.map(p => (
          <div key={p.sku} className="upsell-block__item">
            <OptimizedImage
              className="upsell-block__item-img"
              src={getProductImage(p.name) || '/logo.jpg'}
              alt={p.name}
              loading="lazy"
              width={240}
              widths={[160, 240, 320]}
              sizes="120px"
            />
            <p className="upsell-block__item-name">{p.name}</p>
            <p className="upsell-block__item-price">{p.price}₽</p>
            <button
              className="upsell-block__item-btn"
              onClick={() => onAddItem({
                id: p.sku,
                sku: p.sku,
                name: p.name,
                price: p.price,
                image: getProductImage(p.name)
              })}
            >
              + Добавить
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UpsellBlock;
